import React, { useState } from "react";
import "./ProfileImage.scss";
import { getCdnImageUrl, getImageUrl } from "../../utils/helpers/common";

interface ProfileImageProps {
  url?: string;
  width: number;
  height: number;
  uploadRecord?: any;
}

const ProfileImage = ({
  url,
  width,
  height,
  uploadRecord,
}: ProfileImageProps) => {
  const [imgError, setImgError] = useState(false);

  const getImageSrc = () => {
    if (uploadRecord) {
      if (uploadRecord.medium_image_url) {
        return getCdnImageUrl(uploadRecord.medium_image_url);
      }
      if (uploadRecord.small_image_url) {
        return getCdnImageUrl(uploadRecord.small_image_url);
      }
      if (uploadRecord.storage_key) {
        return getCdnImageUrl(uploadRecord.storage_key);
      }
      if (uploadRecord.original_file_path) {
        return getImageUrl(uploadRecord.original_file_path);
      }
      if (uploadRecord.compressed_file_path) {
        return getImageUrl(uploadRecord.compressed_file_path);
      }
    }

    if (url) {
      if (url.includes("profile-images/") && !url.startsWith("http")) {
        return getCdnImageUrl(url);
      }
      return getImageUrl(url);
    }

    return "";
  };

  const imageSrc = getImageSrc();

  return (
    <img
      src={imgError ? "/images/profile_placeholder.png" : imageSrc}
      alt="profile-image"
      style={{ width, height }}
      className="user-profile-image"
      onError={() => setImgError(true)}
    />
  );
};

export default ProfileImage;
